import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formSave, formFinderSave } from '../actions';
import ActionBar from './ActionBar';

const mapDispatchToProps = (dispatch) => ({
    onSave: (parent, callBack) => {
        if (parent === 'form') {
            dispatch(formSave({ callBack }));
        } else if (parent === 'formFinder') {
            dispatch(formFinderSave({ callBack }));
        }
    },
});

export default withRouter(connect(null, mapDispatchToProps)(ActionBar));
